var Target;
(function (Target) {
    Target["SELF"] = "_self";
    Target["BLANK"] = "_blank";
})(Target || (Target = {}));
var TextLinkTypes;
(function (TextLinkTypes) {
    TextLinkTypes["CONTACT_PERSON"] = "contact-person";
    TextLinkTypes["FOOTER"] = "footer";
    TextLinkTypes["FOOTER_QUICK"] = "footer-quick";
    TextLinkTypes["FOOTER_HELPFUL"] = "footer-helpful";
    TextLinkTypes["FOOTER_SOCIAL"] = "footer-social";
    TextLinkTypes["FOOTER_SERVICE"] = "footer-service";
})(TextLinkTypes || (TextLinkTypes = {}));
var IconSize;
(function (IconSize) {
    IconSize["FOOTNOTE"] = "footnote";
})(IconSize || (IconSize = {}));

export { Target as T, TextLinkTypes as a };

//# sourceMappingURL=roche-text-link.types.js.map